var map = {
	"./casa-mauro/Foto1.jpg": 1911,
	"./casa-meli/Foto1.jpg": 5446,
	"./casa-tomas/Foto1.jpg": 1237,
	"./copina/Foto1.jpg": 5102,
	"./cumbrecita/Foto1.jpg": 9725,
	"./reartes/Foto1.jpg": 4874,
	"./tinogasta/Foto1.jpg": 7842
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5707;